(function(){
  var t=document.querySelector('.menu-toggle'),m=document.getElementById('mobile-nav');
  if(t&&m){t.addEventListener('click',function(){var o=m.classList.toggle('open');t.setAttribute('aria-expanded',o);});
    m.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){m.classList.remove('open');t.setAttribute('aria-expanded','false');});});}
  var form=document.getElementById('lh-buy-form'), sticky=document.querySelector('.sticky-atc');
  function q(sel,root){return (root||document).querySelector(sel);}
  function sync(){
    if(!form) return;
    var v=form.querySelector('input[name="id"]:checked')||form.querySelector('input[name="id"]');
    if(!v) return;
    var title=v.getAttribute('data-title')||'', price=v.getAttribute('data-price')||'', img=v.getAttribute('data-img');
    var n=q('[data-style-name]',form); if(n) n.textContent=title;
    document.querySelectorAll('[data-lh-price],[data-sticky-price]').forEach(function(x){if(price) x.textContent=price;});
    if(sticky){var l=q('[data-sticky-choice]',sticky); if(l) l.textContent=title;}
    if(img) document.querySelectorAll('[data-lh-main] img').forEach(function(i){i.removeAttribute('srcset');i.removeAttribute('sizes');i.src=img;});
    document.querySelectorAll('[data-pick-variant]').forEach(function(c){c.setAttribute('aria-current',c.getAttribute('data-pick-variant')===v.value?'true':'false');});
  }
  if(form){
    form.addEventListener('change',sync); sync();
    form.querySelectorAll('[data-qty]').forEach(function(b){b.addEventListener('click',function(){
      var i=form.querySelector('input[name="quantity"]'); var val=Math.min(10,Math.max(1,(parseInt(i.value,10)||1)+parseInt(b.getAttribute('data-qty'),10))); i.value=val;
    });});
  }
  document.querySelectorAll('[data-pick-variant]').forEach(function(c){c.addEventListener('click',function(){
    if(!form) return; var r=form.querySelector('input[name="id"][value="'+c.getAttribute('data-pick-variant')+'"]'); if(r&&!r.disabled){r.checked=true;sync();}
  });});
  if(sticky&&form&&'IntersectionObserver' in window){
    var trig=document.querySelector('[data-sticky-trigger]')||document.querySelector('main > *'), past=false, buyVisible=false;
    function upd(){var on=past&&!buyVisible;sticky.classList.toggle('show',on);sticky.setAttribute('aria-hidden',!on);}
    new IntersectionObserver(function(e){past=!e[0].isIntersecting&&e[0].boundingClientRect.top<0;upd();}).observe(trig);
    new IntersectionObserver(function(e){buyVisible=e[0].isIntersecting;upd();},{threshold:.15}).observe(form);
  }
})();
